// Иконки заданий проявляются по мере загрузки, а не «выскакивают» пустым местом.
// Когда в DOM появляется иконка, которая ещё не загружена, ей ставится класс
// img-pending (opacity: 0, см. loading.css); по load/error класс снимается и
// иконка плавно проявляется. Уже закешированные картинки показываются сразу.
// Компоненты не меняются — всё через MutationObserver.
const SELECTOR = 'img.task_item_icon, img.custom_icon';
let installed = false;

function prepare(img) {
    if (img.complete && img.naturalWidth > 0) return;
    img.classList.add('img-pending');
    const done = () => {
        img.classList.remove('img-pending');
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
    };
    img.addEventListener('load', done);
    img.addEventListener('error', done);
}

function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches(SELECTOR)) {
        prepare(node);
    } else if (node.querySelectorAll) {
        const imgs = node.querySelectorAll(SELECTOR);
        for (let i = 0; i < imgs.length; i++) prepare(imgs[i]);
    }
}

export function installImageReveal() {
    if (installed || typeof window === 'undefined' || typeof MutationObserver === 'undefined') return;
    installed = true;
    try {
        new MutationObserver((mutations) => {
            for (let i = 0; i < mutations.length; i++) {
                const added = mutations[i].addedNodes;
                for (let j = 0; j < added.length; j++) scan(added[j]);
            }
        }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) { /* без плавного появления иконок — не страшно */ }
}
